import { render, staticRenderFns } from "./AchatCreditsWireConfirmation.vue?vue&type=template&id=0f181072&"
import script from "./AchatCreditsWireConfirmation.vue?vue&type=script&lang=js&"
export * from "./AchatCreditsWireConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports